import * as React from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import AdminConfig from "@system/config/admin";
import Constants from 'src/helper/Constants';
import ShowAlert from "../../component/Global/ShowAlert";
import { LicenseManager } from 'ag-grid-enterprise';

const AdminConsoleHeader = (props) => {
    LicenseManager.setLicenseKey(Constants.agGridLicenseKey)
    const { title, tab, header = "Admin Console" } = props;
    const { adminConsoleTab: { User } } = Constants

    const redirectUserConsole = () => {
        if (tab !== User) {
            window.location.href = AdminConfig.getAdminURL();
        }
    }

    return (
        <>
            <div className='container'>
                <div className="adminconsole-head header-container d-flex align-items-center justify-content-between">
                    <div className={`page-title font-oswald font-light font-38 text-green ${tab !== User ? 'cursor-pointer' : 'cursor-default'}`} onClick={() => redirectUserConsole()}>{header}</div>
                </div>
                <div className="pcn-line-divider"></div>
                <div className="page-title font-oswald font-light font-30">{title}</div>
                <ShowAlert onlyShowMessage={['adminconsole', 'AdminOrderError', 'reprocessOrder']} />
            </div>
        </>
    );
}

export default AdminConsoleHeader;